/* Dar-Mar Ã— BEX â€” predictive unos adrese u EasySell COD formi.
   FAIL-SAFE: ako server ne odgovori ili nesto pukne, forma radi kao i pre. */
(function () {
  "use strict";
  try {
    var API = "https://bex.darmarfashion.com/api/pub";
    var stanje = { settlementId: 0 };
    var box = null, aktivan = null, timer = null, programski = false;

    function esc(t) {
      return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }
    function napravi(inp) {
      var grupa = (inp.closest && inp.closest(".es-input-group")) || inp.parentElement;
      if (getComputedStyle(grupa).position === "static") grupa.style.position = "relative";
      var b = grupa.querySelector('[data-bex="1"]');
      if (!b) {
        b = document.createElement("div");
        b.setAttribute("data-bex", "1");
        b.style.cssText = "position:absolute;left:0;right:0;top:calc(100% + 2px);z-index:99999;background:#fff;" +
          "border:1px solid #dcdcdc;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.18);max-height:220px;" +
          "overflow:auto;display:none;font-size:15px;color:#111;text-align:left;-webkit-overflow-scrolling:touch";
        grupa.appendChild(b);
      }
      box = b;
      return b;
    }
    function sakrij() {
      var svi = document.querySelectorAll('[data-bex="1"]');
      for (var i = 0; i < svi.length; i++) svi[i].style.display = "none";
    }
    function prikazi(inp, stavke, naIzbor) {
      sakrij();
      napravi(inp);
      if (!stavke || !stavke.length) { box.style.display = "none"; return; }
      box.innerHTML = "";
      stavke.forEach(function (s) {
        var d = document.createElement("div");
        d.style.cssText = "padding:11px 12px;cursor:pointer;border-bottom:1px solid #f1f1f1;line-height:1.35";
        d.innerHTML = s.html;
        function uzmi(ev) { ev.preventDefault(); ev.stopPropagation(); try { naIzbor(s.data); } catch (e) {} sakrij(); }
        d.addEventListener("mousedown", uzmi);
        d.addEventListener("touchstart", uzmi, { passive: false });
        box.appendChild(d);
      });
      box.style.display = "block"; aktivan = inp;
    }
    function dohvati(url, cb) {
      fetch(url, { credentials: "omit" })
        .then(function (r) { return r.json(); })
        .then(function (j) { cb(j && j.ok ? (j.data || []) : []); })
        .catch(function () { cb([]); });
    }
    function upisi(inp, v) {
      programski = true;
      inp.value = v;
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
      setTimeout(function () { programski = false; }, 0);
    }
    function skriveno(forma, ime, vrednost) {
      if (!forma) return;
      var el = forma.querySelector('input[name="' + ime + '"]');
      if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = ime; forma.appendChild(el); }
      el.value = vrednost;
    }
    function forma(inp) { return inp.form || (inp.closest ? inp.closest("form") : null); }

    function grad(inp) {
      var q = (inp.value || "").trim();
      if (q.length < 2) { sakrij(); return; }
      dohvati(API + "/mesta?q=" + encodeURIComponent(q), function (data) {
        prikazi(inp, data.map(function (m) {
          return {
            html: "<b>" + esc(m.name) + "</b> <span style='color:#888'>" + esc(m.zip) +
                  (m.municipalityName ? " &middot; " + esc(m.municipalityName) : "") + "</span>",
            data: m
          };
        }), function (m) {
          stanje.settlementId = m.id;
          upisi(inp, m.name);
          var z = document.getElementById("es-zip");
          if (z) upisi(z, m.zip);
          var f = forma(inp);
          skriveno(f, "bex_settlement_id", m.id);
          skriveno(f, "bex_municipality_id", m.municipalityId || "");
          var a = document.getElementById("es-address");
          if (a && !a.value) { try { a.focus(); } catch (e) {} }
        });
      });
    }
    function ulica(inp) {
      var q = (inp.value || "").trim();
      if (!stanje.settlementId || q.length < 2) { sakrij(); return; }
      dohvati(API + "/ulice?settlementId=" + stanje.settlementId + "&q=" + encodeURIComponent(q), function (data) {
        prikazi(inp, data.map(function (u) { return { html: esc(u.name), data: u }; }), function (u) {
          upisi(inp, u.name + " ");
          skriveno(forma(inp), "bex_street_id", u.id);
          try { inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length); } catch (e) {}
        });
      });
    }

    document.addEventListener("input", function (e) {
      var t = e.target;
      if (programski) return;
      if (!t || !t.id || (t.id !== "es-city" && t.id !== "es-address")) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        try { (t.id === "es-city" ? grad : ulica)(t); } catch (err) { sakrij(); }
      }, 250);
    }, true);
    document.addEventListener("click", function (e) {
      if (box && !box.contains(e.target) && e.target !== aktivan) sakrij();
    }, true);
    window.addEventListener("resize", sakrij);
  } catch (e) { /* tiho â€” forma mora da radi i ako widget pukne */ }
})();

/* === BEX dodatak (2026-07-22): "Mesto / Grad" ide iznad "Ulica i broj" u EasySell formi.
   Razlog: predlozi ulica rade tek kad je grad izabran, pa grad mora prvi.
   FAIL-SAFE: sve u try/catch - ako bilo sta pukne, forma ostaje kakva je bila. */
(function () {
  "use strict";
  function bexGradIznadUlice() {
    try {
      var city = document.querySelector(".es-city-group");
      var street = document.getElementById("es-address");
      if (!city || !street) return;
      var parent = city.parentElement;
      if (!parent) return;
      var streetBlok = street;
      while (streetBlok && streetBlok.parentElement !== parent) streetBlok = streetBlok.parentElement;
      if (!streetBlok || streetBlok === city) return;
      if (streetBlok.compareDocumentPosition(city) & Node.DOCUMENT_POSITION_FOLLOWING) {
        parent.insertBefore(city, streetBlok);
      }
    } catch (e) { /* tiho - ne diraj formu */ }
  }
  try {
    new MutationObserver(bexGradIznadUlice).observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bexGradIznadUlice);
    bexGradIznadUlice();
  } catch (e) { /* tiho */ }
})();
